import React from 'react';

import Card from './card';


export default function FormCard(props) {
  return (
    <Card {...props} defaultClasses="form-card" />
  );
}
